{
  "version": 1,
  "asset_id": "6ffbbb68-d817-4ab1-93b3-d05bfabd9e9b",
  "project_id": "39db9d3d-7b53-4499-b84e-1b89accf167e",
  "url": "/__l5e/assets-v1/6ffbbb68-d817-4ab1-93b3-d05bfabd9e9b/learner-a-plus-cutout.webp",
  "r2_key": "a/v1/39db9d3d-7b53-4499-b84e-1b89accf167e/6ffbbb68-d817-4ab1-93b3-d05bfabd9e9b/learner-a-plus-cutout.webp",
  "original_filename": "learner-a-plus-cutout.webp",
  "size": 36058,
  "content_type": "image/webp",
  "created_at": "2026-08-18T08:36:42Z"
}
